<template>
  <div>
    <GoodsCon v-if="type === 0"></GoodsCon>
    <GoodsConSimple v-if="type === 1"></GoodsConSimple>
  </div>
</template>
<script>
import {getProductType,} from "@api/store";
import GoodsCon from "@views/shop/GoodsCon";
import GoodsConSimple from "@views/shop/GoodsConSimple";
let NAME = "GoodsConfen";
export default {
  name: NAME,
  components: {
    GoodsCon,
    GoodsConSimple,
  },
  data: function() {
    return {
      type: 2,
    };
  },
  updated() {
    // window.scroll(0, 0);
  },
  mounted: function() {
    this.id = this.$route.params.id;
    this.productCon();
  },
  methods: {
    //产品详情接口；
    productCon: function() {
      let that = this;
      getProductType(that.id)
        .then(res => {
          that.$set(that, "type", res.data.type);
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
  }
};
</script>
<style scoped>
</style>
